module.exports = __webpack_public_path__ + "static/media/landline_2.e7505c7f.svg";